import React, {useState,useEffect,Fragment} from 'react';
import QuestionType from '../QuestionType/QuestionType';
import {Route} from 'react-router-dom';
import Instructions from '../Instructions';
import {usePrevious} from '../../../hooks/usePrevious';
import PageHeader from '../../PageHeader/PageHeader';
import {useSectionCompleted} from '../../../hooks/useSectionCompleted';

const QuestionSection = props => {

  const [thisAnswer, setThisAnswer] = useState(undefined);
  const [questionIndex,setQuestionIndex] = useState(-1);
  const [valid, setValid] = useState(true)
  const prevQuestionIndex = usePrevious(questionIndex);
  const {
    answers,
    setAnswers,
    sections=[],
    // questionnaire=[],
    match:{params:{section}={}}={},
    version=undefined,
    dataStore,
    pathBase
  } = props;

  const thisSection = sections.find(item => item.key === section)
  const title = thisSection ? thisSection.title : ''
  const keyIndex = thisSection ? thisSection.keyIndex : ''

  const sectionQuestions = thisSection && thisSection.questions
  const sectionComplete = useSectionCompleted(sectionQuestions, keyIndex);
  
  useEffect(() => {
    const operators = {
      '+' : (a,b) => a + b,
      '-' : (a,b) => a - b,
      '=' : (a,b) => a === b,
      '!=' : (a,b) => a !== b,
      '<' : (a,b) => a < b,
      '>' : (a,b) => a > b
    }
  
    if (questionIndex > -1 && questionIndex < sectionQuestions.length) {
      const {condition, key} = sectionQuestions[questionIndex];
      if (condition) {
        const {lhs,operator:o,rhs} = condition;
        
        let lhsAnswer = undefined
        if (lhs === 'prefix') {
          if (keyIndex && keyIndex !== '' && keyIndex.length > 1) {
            lhsAnswer = keyIndex.charAt(1) // Ex: -P0 is 'P'
          }
        } else {
          lhsAnswer = answers[`${lhs}${keyIndex}`]
          // Answer might be in a different non-repeating section
          lhsAnswer = lhsAnswer ? lhsAnswer : answers[lhs] 
        }

        const c = operators[o || '='](lhsAnswer, rhs);

        if (!c) {
          handleAnswer(key, '')
          if (prevQuestionIndex > questionIndex) {
            handleBackLink();
          } else {
            handleNextLink();
          }
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[questionIndex, sectionQuestions, handleNextLink, handleBackLink,
     prevQuestionIndex, answers, keyIndex]);

  function handleAnswer(key,answer) {
    const newAnswers = {...answers,[key]:answer};
    setAnswers(newAnswers);
    setThisAnswer({...thisAnswer, [key]: answer})
  }

  function handleMultipleAnswers(key,answer) {
    // Delay saving anwers in the multiple case to ensure the answer is verified
    // This may apply to the broader case of a single answer as well, but
    // causion is being appied to not break existing code.
    setThisAnswer({...thisAnswer, [key]: answer})
  }

  function saveThisAnswer() {
    if (thisAnswer) {
      const newAnswers = {...answers, ...thisAnswer};
      setAnswers(newAnswers);
      dataStore.store({...thisAnswer, version})
      setThisAnswer(undefined)
    }
  }

  function handleNextLink() {
    if (!valid) return
    saveThisAnswer()
    if (questionIndex === sectionQuestions.length) {
      props.history.push(`/${pathBase}/${section}`);
      setQuestionIndex(-1);
    } else if (questionIndex === sectionQuestions.length - 1) {
      props.history.push(`/${pathBase}/${section}`);
      setQuestionIndex(questionIndex+1);
    } else {
      props.history.push(`/${pathBase}/${section}/${sectionQuestions[questionIndex+1].key}`);
      setQuestionIndex(questionIndex+1);
    }
  }

  function handleBackLink() {
    if (!valid) return
    saveThisAnswer()
    if (questionIndex > 0) {
      props.history.push(`/${pathBase}/${section}/${sectionQuestions[questionIndex-1].key}`);
      setQuestionIndex(questionIndex-1);
    } else {
      props.history.push(`/${pathBase}/${section}`);
      setQuestionIndex(-1);
    }
  }

  function completeSection() {
    props.history.push(`/${pathBase}`);
  }

  function markValid(value) {
    setValid(value)
  }

  return (
    <Fragment>
      <PageHeader title={title} />
      <Route
        exact
        path={`/${pathBase}/:section`}
        render={props => (
          <Instructions
            endOfSection={questionIndex === sectionQuestions.length}
            sectionComplete={sectionComplete}
            handleNextLink={handleNextLink}
            handleComplete={completeSection}
            pathBase={pathBase}
          />
        )}
      />
      <Route
        path={`/${pathBase}/:section/:key`}
        render={props => (
          <QuestionType
            {...props}
            answers={answers}
            questionnaire={sectionQuestions}
            setQuestionIndex={setQuestionIndex}
            handleAnswer={handleAnswer}
            handleMultipleAnswers={handleMultipleAnswers}
            markValid={markValid}
            handleNextLink={handleNextLink}
            handleBackLink={handleBackLink}
            pathBase={pathBase}
          />
        )}
      />
    </Fragment>
  );
};

export default QuestionSection;
